import { render } from "./ReceiversPage.vue?vue&type=template&id=8c59dede"
import script from "./ReceiversPage.vue?vue&type=script&lang=js"
export * from "./ReceiversPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__